var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommonIconGoogle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3462 19.3959C34.3462 18.1609 34.2396 16.9734 34.0417 15.8334H18.2693V22.5784H27.2821C26.8863 24.7475 25.6988 26.5842 23.9175 27.8192V32.205H29.3526C32.5193 29.165 34.3462 24.7 34.3462 19.3959Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2692 36.4167C22.7908 36.4167 26.5817 34.865 29.3525 32.205L23.9174 27.8192C22.4254 28.8642 20.5224 29.4975 18.2692 29.4975C13.915 29.4975 10.2155 26.4417 8.89096 22.325H3.31885V26.8217C6.07446 32.5058 11.7227 36.4167 18.2692 36.4167Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89105 22.3092C8.55611 21.2642 8.3582 20.1558 8.3582 19C8.3582 17.8442 8.55611 16.7358 8.89105 15.6908V11.1942H3.31894C2.17711 13.5375 1.52246 16.1817 1.52246 19C1.52246 21.8183 2.17711 24.4625 3.31894 26.8058L7.65788 23.2908L8.89105 22.3092Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2692 8.51837C20.7355 8.51837 22.9278 9.40504 24.6786 11.115L29.4743 6.12754C26.5664 3.30921 22.7908 1.58337 18.2692 1.58337C11.7227 1.58337 6.07446 5.49421 3.31885 11.1942L8.89096 15.6909C10.2155 11.5742 13.915 8.51837 18.2692 8.51837Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconGoogle);
export default __webpack_public_path__ + "static/media/common_icon_google.3d897ebcbf632197f4955b82c3160972.svg";
export { ForwardRef as ReactComponent };